import { render, staticRenderFns } from "./actualizacionPrecioMasivo.vue?vue&type=template&id=e4436aa8&scoped=true"
import script from "./actualizacionPrecioMasivo.vue?vue&type=script&lang=js"
export * from "./actualizacionPrecioMasivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4436aa8",
  null
  
)

export default component.exports